import React, { useEffect, useState } from "react";
import { Table, Card, Row, Col } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Link, useParams } from 'react-router-dom';
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import { DateRangePicker } from "react-date-range";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./MerchantSubscription.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';
import moment from 'moment';
import { QRCodeSVG } from 'qrcode.react';
import { gettoastsuccess } from '../../Utils/Common';


const paymentIcons = {
  CreditCard: "assests/images/visa.png",
  BankTransfer: "assests/images/bank-tranfer.png",
  PayPal: "assests/images/paypal.png"
};

const MerchantSubscription = () => {
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  const [inputs, setInputs] = useState({ id: '', store_name: '', merchant_id: '', join_date: '', street_name: '', logo: '', owner_name: '', dob: '', category_name: '', stripe_express: 0, mobile: '', salesperson: '', subcategory_name: '', subscription_status: '', accepted_per_time_slot: 0, auto_accept_during_working_hours: '', store_email: '', no_of_customers: 0, be_confirmed: '', auto_refuse: 0, url: '', sales_id: '', store_policy: '' });

  const [employeesubscription, setEmployeesubscription] = useState([]);
  const [paymenthistory, setPaymenthistory] = useState([]);

  const [workinghours, setWorkinghours] = useState([]);


  const [paylinks, setPaylinks] = useState([]);
  const [payperpage, setPayperpage] = useState(10);
  const [paytotalrec, setPaytotalrec] = useState(0);

  const [merchantemployee, setMerchantemployee] = useState([]);
  const [emplinks, setEmplinks] = useState([]);
  const [empperpage, setEmpperpage] = useState(10);
  const [emptotalrec, setEmptotalrec] = useState(0);

  const [merchantproduct, setMerchantproduct] = useState([]);
  const [prolinks, setProlinks] = useState([]);
  const [properpage, setProperpage] = useState(10);
  const [prototalrec, setPrototalrec] = useState(0);

  const [merchantcoupon, setMerchantcoupon] = useState([]);
  const [coulinks, setCoulinks] = useState([]);
  const [couperpage, setCouperpage] = useState(10);
  const [coutotalrec, setCoutotalrec] = useState(0);

  const [merchantcusrec, setMerchantcusrec] = useState([]);
  const [cuskeyword, setcusKeyword] = useState('');
  const [sortcusOrder, setSortcusOrder] = useState("asc");
  const [merchantcustotal, setMerchantcustotal] = useState(0);
  const [merchantcustomer, setMerchantcustomer] = useState([]);
  const [cuslinks, setCuslinks] = useState([]);
  const [cusperpage, setCusperpage] = useState(10);
  const [custotalrec, setCustotalrec] = useState(0);
  const [merchantcusrecid, setMerchantcusrecid] = useState(0);


  const [merchantincome, setMerchantincome] = useState([]);
  const [merchantcurrentmonthtotal, setMerchantcurrentmonthtotal] = useState(0);

  const [ordkeyword, setordKeyword] = useState('');
  const [sortordOrder, setSortordOrder] = useState("asc");
  const [merchantorder, setMerchantorder] = useState([]);
  const [ordlinks, setOrdlinks] = useState([]);
  const [ordperpage, setOrdperpage] = useState(10);
  const [ordtotalrec, setOrdtotalrec] = useState(0);

  const [couponmodal, setCouponmodal] = useState({});

  const [showcus, setShowcus] = useState(false);
  const handleClosecus = () => setShowcus(false);


  const [show, setShow] = useState(false);
  //const handleShow = () => setShow(true);
  const handleShow = (val) => {
    setCouponmodal(val);
    setShow(true);
  }

  const handleClose = () => setShow(false);

  const [show2, setShow2] = useState(false);
  //const handleShow2 = () => setShow2(true);
  const handleClose2 = () => setShow2(false);

  const [show3, setShow3] = useState(false);
  //const handleShow3 = () => setShow3(true);
  const handleClose3 = () => setShow3(false);

  //const [selectedRangeStartInc, setSelectedRangeStartInc] = useState('');
  //const [selectedRangeEndInc, setSelectedRangeEndInc] = useState('');

  const [showCalendarInc, setShowCalendarInc] = useState(false);
  const [selectedRangeInc, setSelectedRangeInc] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [selectedRangeStartCou, setSelectedRangeStartCou] = useState('');
  const [selectedRangeEndCou, setSelectedRangeEndCou] = useState('');

  const [showCalendarCou, setShowCalendarCou] = useState(false);
  const [selectedRangeCou, setSelectedRangeCou] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedRange, setSelectedRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const handleSelect = (ranges) => {
    setSelectedRange([ranges.selection]);
  };

  const closeCalendar = () => setShowCalendar(false);

  const [isMobile, setIsMobile] = useState(false);
  const [prAccordionOpen, setprAccordionOpen] = useState(false);
  const [cpAccordionOpen, setcpAccordionOpen] = useState(false);
  const [emAccordionOpen, setemAccordionOpen] = useState(false);

  const [empsubAccordionOpen, setEmpSubAccordionOpen] = useState(false);
  const [payAccordionOpen, setPayAccordionOpen] = useState(false);

  const [showQRPopup, setShowQRPopup] = useState(false);
  const handleQRClick = () => {
    if (window.innerWidth <= 768) {
      setShowQRPopup(true);
    }
  };
  const [activeTab, setActiveTab] = useState('subscription status');
  const tabHeaderNames = {
    "subscription status": "Merchant Subscription",
    "employees": "Merchant Employee",
    "products": "Merchant Products",
    "coupons": "Merchant Coupons",
    "customers": "Merchant Customers",
    "income & forecast": "Merchant Income & Forecast",
    "Working Hours": "Merchant Working Hours",
    "Orders/Appointments": "Orders/Appointments",
  };
  const tabHeadings = {
    "subscription status": "Merchant Profile",
    "employees": "Employee Profile",
    "products": "Profile",
    "coupons": "Profile",
    "customers": "Profile",
    "income & forecast": "Profile",
    "Working Hours": "Profile",
    "Orders/Appointments": "Orders/Appointments",
  };
  const handleShowcus = (val, id) => {
    setMerchantcusrec(val);
    setMerchantcusrecid(id)
    setShowcus(true);
  }
  const handleCusSort = () => {
    setLoading(true);
    var ascdesc = sortcusOrder === "asc" ? "desc" : "asc";
    setSortcusOrder(ascdesc);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', cusperpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', cuskeyword);
    API.post('backoffice_merchant_customers', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantcustotal(response.data.data.total_customers);
          setMerchantcustomer(response.data.data.customers.data);
          setCuslinks(response.data.data.customers.links);
          setCustotalrec(response.data.data.customers.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleCusInputChangeauto = (event) => {
    var keyword = event.target.value;
    setcusKeyword(keyword);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', cusperpage);
    formData.append('page', 1);
    formData.append('order_by', sortcusOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_merchant_customers', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantcustotal(response.data.data.total_customers);
          setMerchantcustomer(response.data.data.customers.data);
          setCuslinks(response.data.data.customers.links);
          setCustotalrec(response.data.data.customers.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }
  const handlecustomerRowsChange = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setCusperpage(perpage);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    API.post('backoffice_merchant_customers', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantcustotal(response.data.data.total_customers);
          setMerchantcustomer(response.data.data.customers.data);
          setCuslinks(response.data.data.customers.links);
          setCustotalrec(response.data.data.customers.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleCusPageChange = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', cusperpage);
    formData.append('page', page);
    API.post('backoffice_merchant_customers', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantcustotal(response.data.data.total_customers);
          setMerchantcustomer(response.data.data.customers.data);
          setCuslinks(response.data.data.customers.links);
          setCustotalrec(response.data.data.customers.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handlecouponRowsChange = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setCouperpage(perpage);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    if (selectedRangeStartCou !== '' && selectedRangeEndCou !== '') {
      var start_date = moment(selectedRangeStartCou).format('YYYY-MM-DD');
      var end_date = moment(selectedRangeEndCou).format('YYYY-MM-DD');
      formData.append('start_date', start_date);
      formData.append('end_date', end_date);
    }
    API.post('backoffice_merchant_coupon', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantcoupon(response.data.data.payment_history.data);
          setCoulinks(response.data.data.payment_history.links);
          setCoutotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };

  const handleCouPageChange = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', couperpage);
    formData.append('page', page);
    if (selectedRangeStartCou !== '' && selectedRangeEndCou !== '') {
      var start_date = moment(selectedRangeStartCou).format('YYYY-MM-DD');
      var end_date = moment(selectedRangeEndCou).format('YYYY-MM-DD');
      formData.append('start_date', start_date);
      formData.append('end_date', end_date);
    }
    API.post('backoffice_merchant_coupon', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantcoupon(response.data.data.payment_history.data);
          setCoulinks(response.data.data.payment_history.links);
          setCoutotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleSelectCou = (ranges) => {
    setSelectedRangeCou([ranges.selection]);
    setSelectedRangeStartCou(ranges.selection.startDate);
    setSelectedRangeEndCou(ranges.selection.endDate);
  };
  const closeCalendarCou = () => {
    setShowCalendarCou(false);
    setLoading(true);

    var start_date = moment(selectedRangeCou[0].startDate).format('YYYY-MM-DD');
    var end_date = moment(selectedRangeCou[0].endDate).format('YYYY-MM-DD');

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', couperpage);
    formData.append('page', 1);
    formData.append('start_date', start_date);
    formData.append('end_date', end_date);
    API.post('backoffice_merchant_coupon', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantcoupon(response.data.data.payment_history.data);
          setCoulinks(response.data.data.payment_history.links);
          setCoutotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }

  const handleproRowsChange = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setProperpage(perpage);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    API.post('backoffice_merchant_product', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantproduct(response.data.data.payment_history.data);
          setProlinks(response.data.data.payment_history.links);
          setPrototalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleProdPageChange = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', properpage);
    formData.append('page', page);
    API.post('backoffice_merchant_product', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantproduct(response.data.data.payment_history.data);
          setProlinks(response.data.data.payment_history.links);
          setPrototalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handlesetiRowsChange = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setEmpperpage(perpage);

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    API.post('backoffice_merchant_employee', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantemployee(response.data.data.payment_history.data);
          setEmplinks(response.data.data.payment_history.links);
          setEmptotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleEmpPageChange = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', empperpage);
    formData.append('page', page);
    API.post('backoffice_merchant_employee', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantemployee(response.data.data.payment_history.data);
          setEmplinks(response.data.data.payment_history.links);
          setEmptotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleRowsChange = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setPayperpage(perpage);

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    API.post('backoffice_merchant_detail', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setPaymenthistory(response.data.data.payment_history.data);
          setPaylinks(response.data.data.payment_history.links);
          setPaytotalrec(response.data.data.payment_history.total);

        }
      }).catch(error => {
        setLoading(false);
      });
  };

  const handlePageChange = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', payperpage);
    formData.append('page', page);
    API.post('backoffice_merchant_detail', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setPaymenthistory(response.data.data.payment_history.data);
          setPaylinks(response.data.data.payment_history.links);
          setPaytotalrec(response.data.data.payment_history.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleSelectInc = (ranges) => {
    setSelectedRangeInc([ranges.selection]);
    //setSelectedRangeStartInc(ranges.selection.startDate);
    //setSelectedRangeEndInc(ranges.selection.endDate);
  };
  const closeCalendarInc = () => {
    setShowCalendarInc(false);
    setLoading(true);

    var start_date = moment(selectedRangeInc[0].startDate).format('YYYY-MM-DD');
    var end_date = moment(selectedRangeInc[0].endDate).format('YYYY-MM-DD');

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('id', id);
    formData.append('start_date', start_date);
    formData.append('end_date', end_date);
    API.post('backoffice_merchant_income_forecast', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantincome(response.data.data.all_array);
          setMerchantcurrentmonthtotal(response.data.data.current_month_total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleOrdInputChangeauto = (event) => {
    var keyword = event.target.value;
    setordKeyword(keyword);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', ordperpage);
    formData.append('page', 1);
    formData.append('order_by', sortcusOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_merchant_order', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);

          setMerchantorder(response.data.data.data);
          setOrdlinks(response.data.data.links);
          setOrdtotalrec(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleOrdSort = () => {
    setLoading(true);
    var ascdesc = sortordOrder === "asc" ? "desc" : "asc";
    setSortordOrder(ascdesc);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', ordperpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', ordkeyword);
    API.post('backoffice_merchant_order', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantorder(response.data.data.data);
          setOrdlinks(response.data.data.links);
          setOrdtotalrec(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleorderRowsChange = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setOrdperpage(perpage);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', perpage);
    formData.append('page', 1);
    API.post('backoffice_merchant_order', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantorder(response.data.data.data);
          setOrdlinks(response.data.data.links);
          setOrdtotalrec(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleOrdPageChange = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    formData.append('per_page', cusperpage);
    formData.append('page', page);
    API.post('backoffice_merchant_order', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchantorder(response.data.data.data);
          setOrdlinks(response.data.data.links);
          setOrdtotalrec(response.data.data.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const setGetActiveTab = (key) => {
    setActiveTab(key);
    console.log(key);
    setLoading(true);
    if (key === 'employees') {

      let formData = new FormData();
      formData.append('token', localStorage.getItem("token"));
      formData.append('store_id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_merchant_employee', formData)
        .then(response => {
          if (response.data.status === 0) {
            setLoading(false);
          } else {
            setLoading(false);
            setMerchantemployee(response.data.data.payment_history.data);
            setEmplinks(response.data.data.payment_history.links);
            setEmptotalrec(response.data.data.payment_history.total);
          }
        }).catch(error => {
          setLoading(false);
        });
    } else if (key === 'products') {
      let formData = new FormData();
      formData.append('token', localStorage.getItem("token"));
      formData.append('store_id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_merchant_product', formData)
        .then(response => {
          if (response.data.status === 0) {
            setLoading(false);
          } else {
            setLoading(false);
            setMerchantproduct(response.data.data.payment_history.data);
            setProlinks(response.data.data.payment_history.links);
            setPrototalrec(response.data.data.payment_history.total);
          }
        }).catch(error => {
          setLoading(false);
        });
    } else if (key === 'coupons') {
      let formData = new FormData();
      formData.append('token', localStorage.getItem("token"));
      formData.append('store_id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_merchant_coupon', formData)
        .then(response => {
          if (response.data.status === 0) {
            setLoading(false);
          } else {
            setLoading(false);
            setMerchantcoupon(response.data.data.payment_history.data);
            setCoulinks(response.data.data.payment_history.links);
            setCoutotalrec(response.data.data.payment_history.total);
          }
        }).catch(error => {
          setLoading(false);
        });
    } else if (key === 'customers') {
      let formData = new FormData();
      formData.append('token', localStorage.getItem("token"));
      formData.append('store_id', id);
      formData.append('per_page', 10);
      formData.append('page', 1);
      API.post('backoffice_merchant_customers', formData)
        .then(response => {
          if (response.data.status === 0) {
            setLoading(false);
          } else {
            setLoading(false);
            setMerchantcustotal(response.data.data.total_customers);
            setMerchantcustomer(response.data.data.customers.data);
            setCuslinks(response.data.data.customers.links);
            setCustotalrec(response.data.data.customers.total);
          }
        }).catch(error => {
          setLoading(false);
        });
    } else if (key === 'income & forecast') {
      let formData = new FormData();
      formData.append('token', localStorage.getItem("token"));
      formData.append('id', id);
      API.post('backoffice_merchant_income_forecast', formData)
        .then(response => {
          if (response.data.status === 0) {
            setLoading(false);
          } else {
            setLoading(false);
            setMerchantincome(response.data.data.all_array);
            setMerchantcurrentmonthtotal(response.data.data.current_month_total);
          }
        }).catch(error => {
          setLoading(false);
        });
    } else if (key === 'workinghours') {
      setLoading(false);
    } else if (key === 'orders/appointments') {
      let formData = new FormData();
      formData.append('token', localStorage.getItem("token"));
      formData.append('store_id', id);
      API.post('backoffice_merchant_order', formData)
        .then(response => {
          if (response.data.status === 0) {
            setLoading(false);
          } else {
            setLoading(false);

            setMerchantorder(response.data.data.data);
            setOrdlinks(response.data.data.links);
            setOrdtotalrec(response.data.data.total);
          }
        }).catch(error => {
          setLoading(false);
        });
    }
  }
  const renderTabContent = () => {
    switch (activeTab) {
      case "subscription status":
        return <div className="col-12 holisti">
          <div className="col-12 holisti mt-4">
            <Card className="h-100">
              <Card.Title className="d-none d-md-block">Subscription and Payment History</Card.Title>
              <div className="table-ro mt-2 d-none d-md-block">
                <Table
                  responsive
                  className="table-no-last-border mb-0"
                >
                  <thead className="table">
                    <tr className="custom-header">
                      <th className="lft">Date</th>
                      <th>Receipt #</th>
                      <th>Amount ($)</th>
                      <th>Payment Method</th>
                      <th>Transaction #</th>
                      <th>Subscription Plan</th>
                      <th>Transaction Date</th>
                      <th>Next Billing Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymenthistory.map((item, index) => (
                      <tr key={index}>
                        <td className="lef">{item.date}</td>
                        <td>
                          {
                            item.is_upgrade_or_downgrade !== 0 ? <Link to={`/mer-receipts-new/${item.id}/${id}/${item.subscription_transaction_id}`} className="">{item.recipt}</Link> : <Link to={`/mer-receipts/${item.id}/${id}/${item.subscription_transaction_id}`} className="">{item.recipt}</Link>
                          }
                        </td>
                        <td>{item.amount}</td>
                        <td>{item.payment_method}</td>
                        <td>{item.txn_id ? item.txn_id : '-'}</td>
                        <td>{item.plan_name}</td>
                        <td className="ref">{item.date}</td>
                        <td className="ref">{item.end_date}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
                onClick={() => isMobile && setPayAccordionOpen(!payAccordionOpen)}
                style={{ cursor: isMobile ? "pointer" : "default" }}
              >
                <h5>Payment History</h5>
                {isMobile && (
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      (payAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                    }
                    alt="Toggle Arrow"
                  />
                )}
              </div>
              {(!isMobile || payAccordionOpen) && (
                <>
                  <div className="d-md-none mb-3 ev-mobilex">
                    {paymenthistory.map((item, index) => (
                      <div
                        key={index}
                        className="col-12 mb-3 main"
                      >
                        <div className="d-flex justify-content-between align-items-center fir mb-2">
                          <h2>{item.date}</h2>
                          <h3>{item.plan_name}</h3>
                        </div>
                        <div className="d-flex two mb-1">
                          <div className="aemou">{item.amount}</div>
                          <div key={index}>
                            {paymentIcons['CreditCard'] && (
                              <img
                                src={process.env.REACT_APP_BASE_URL + paymentIcons['CreditCard']}
                                alt={item.payment_method}
                                className="img-fluid ms-3"
                              />
                            )}
                          </div>
                        </div>
                        <h4>
                          {item.end_date} - Recurrent Charge Date
                        </h4>
                        <div className="row ojuy">
                          <div className="col-6">
                            <h2>Transaction #</h2>
                            <h3>{item.txn_id ? item.txn_id : '-'}</h3>
                          </div>
                          <div className="col-6">
                            <h2>Receipt #</h2>
                            <h3><Link to={`/mer-receipts/${item.id}/${id}/${item.subscription_transaction_id}`}>{item.recipt}</Link></h3>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2 gap-2">
                    <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                      <label>Show rows:</label>
                      <select
                        value={payperpage}
                        onChange={handleRowsChange}
                        className="form-select w-auto"
                      >
                        <option value={10}>10 items</option>
                        <option value={15}>15 items</option>
                        <option value={20}>20 items</option>
                        <option value={25}>25 items</option>
                      </select>
                    </div>
                    {paytotalrec > 0 && (
                      <nav>
                        <ul className="pagination pagination-sm mb-0">

                          {paylinks.map((link, index) => {
                            var label = link.label;
                            if (label.includes("Previous")) label = "<";
                            if (label.includes("Next")) label = ">";

                            return (
                              <>
                                <li className={`page-item ${link.active ? "active" : ""}`}>
                                  <button
                                    className={`page-link ${!link.url ? "disabled" : ""}`}
                                    onClick={() => {
                                      if (link.url) {
                                        const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                        handlePageChange(pageNumber);
                                      }
                                    }}
                                  >
                                    {label}
                                  </button>
                                </li>
                              </>
                            );
                          })}
                        </ul>
                      </nav>
                    )}
                  </div>
                </>
              )}
            </Card>
          </div>
          <Card className="h-100 mt-4">
            <Card.Title className="d-none d-md-block">Employee Subscription Plan</Card.Title>
            <div className="table-ro mt-2 d-none d-md-block">
              <div style={{ maxHeight: "380px", overflowY: "auto" }}>
                <Table
                  responsive
                  className="table-no-last-border mb-0"
                >
                  <thead className="table">
                    <tr className="custom-header">
                      <th className="lft">Date</th>
                      <th>Employee Name</th>
                      <th>Status</th>
                      <th>Price</th>
                      <th>Payment Method</th>
                      <th>Recurrent Date</th>
                      <th>Receipt</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employeesubscription.map((item, index) => (
                      <tr key={index}>
                        <td className="lef">{item.date}</td>
                        <td>{item.employee_name}</td>
                        <td>{item.stripe_status}</td>
                        <td>{item.amount}</td>
                        <td>{item.payment_method}</td>
                        <td className="ref">{item.end_date}</td>
                        <td><a href={`/mer-employee-receipts/${item.id}/${id}/${item.employee_transaction_id}`}>{item.recipt}</a></td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setEmpSubAccordionOpen(!empsubAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Employee Subscription Plan</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (empsubAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || empsubAccordionOpen) && (
              <>
                <div className="d-md-none ev-mobile">
                  {employeesubscription.map((item, index) => (
                    <div className="card horos mb-3" key={index}>
                      <div className="d-flex justify-content-between mb-1">
                        <div className="detes">{item.date}</div>
                        <div className="pran">{item.plan_name}</div>
                      </div>
                      <div className="d-flex">
                        <div className="plige">{item.amount}</div>
                        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/visa.png'} alt="" className="img-fluid ms-3" />
                      </div>
                      <div className="change-detes">{item.end_date} - Recurrent Charge Date</div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </Card>
        </div>;
      case "employees":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <Card.Title className="d-none d-md-block">Employees</Card.Title>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Join Date</th>
                    <th>Employee ID</th>
                    <th>Phone #</th>
                    <th>Email</th>
                    <th>Commission ($)</th>
                    <th>Orders/Invoices</th>
                    <th>Active</th>
                  </tr>
                </thead>
                <tbody>
                  {merchantemployee.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.join_date}</td>
                      <td>
                        {parseInt(localStorage.getItem("department")) === 7 ? (
                          <Link to={`${process.env.REACT_APP_BASE_URL}dashboard-sales-vp-of-sales/${item.id}`}>
                            {item.customers_id}
                          </Link>
                        ) : (
                          <Link to={process.env.REACT_APP_BASE_URL + ""}>
                            {item.customers_id}
                          </Link>
                        )}

                      </td>
                      <td>{item.phone}</td>
                      <td>{item.email}</td>
                      <td>{item.commission}</td>
                      <td>{item.orders_invoices}</td>
                      <td className="ref">{item.status ? 'Yes' : `No/${item.end_date}`}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setemAccordionOpen(!emAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Employees</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (emAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || emAccordionOpen) && (
              <>
                <div className="d-md-none mb-3 ev-mobilex">
                  {merchantemployee.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      {/* Top row: Join date and Active tag */}
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="joily d-flex"><div className="date">{item.join_date} -</div> Join Date</div>
                        <div className="pran">{item.status ? 'Yes' : `No/${item.end_date}`}</div>
                      </div>

                      {/* Image + Name + Contact */}
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                          <img
                            src={item.image}
                            alt={item.name}
                            className="ppt1"
                          />
                          <div className="ms-2 fgtrx">
                            <Link to={`${process.env.REACT_APP_BASE_URL}dashboard-merchants-employees/${item.id}/${id}`}>{item.name}</Link>
                          </div>
                        </div>
                        <div className="kayde">${item.commission.toFixed(2)}</div>
                      </div>

                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="erroo d-flex align-items-center"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/emiyy.png'} alt={item.name} className="me-2" />{item.email}</div>
                        <div className="invvc">Orders/Invoices</div>
                      </div>

                      {/* Commission + Orders/Invoices */}
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="phony d-flex align-items-center"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/phonty.png'} alt={item.name} className="me-2" />{item.phone}</div>
                        <div className="devifr">{item.orders_invoices}</div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={empperpage}
                      onChange={handlesetiRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>
                  {emptotalrec > 0 && (
                    <nav>
                      <ul className="pagination pagination-sm mb-0">

                        {emplinks.map((link, index) => {
                          var label = link.label;
                          if (label.includes("Previous")) label = "<";
                          if (label.includes("Next")) label = ">";

                          return (
                            <>
                              <li className={`page-item ${link.active ? "active" : ""}`}>
                                <button
                                  className={`page-link ${!link.url ? "disabled" : ""}`}
                                  onClick={() => {
                                    if (link.url) {
                                      const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                      handleEmpPageChange(pageNumber);
                                    }
                                  }}
                                >
                                  {label}
                                </button>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </nav>
                  )}
                </div>
              </>
            )}
          </Card>
        </div>;
      case "products":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <Card.Title className="d-none d-md-block">Product/Service Information</Card.Title>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Category</th>
                    <th>Product/Service</th>
                    <th>Description</th>
                    <th>Picture</th>
                    <th>Price $</th>
                    <th>During (Min)</th>
                    <th>Special Instructions</th>
                  </tr>
                </thead>
                <tbody>
                  {merchantproduct.map((item, index) => (
                    <tr key={index}>
                      <td className="lef" style={{ cursor: 'pointer' }}>{item.category_name}</td>
                      <td>{item.name}</td>
                      <td>{item.description}</td>
                      <td><img src={item.image_thuumb} alt={item.name} className="img-fluid me-2" width="50" height="50" /></td>
                      <td>{item.price}</td>

                      <td>{item.duration_in_minutes ? item.duration_in_minutes : "-"}</td>
                      <td className="ref">{item.special_instructions}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setprAccordionOpen(!prAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Product/Service Information</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (prAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || prAccordionOpen) && (
              <>
                <div className="d-md-none ev-mobilex">
                  {merchantproduct.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="joxily">{item.category_name}</div>
                        <div className="pran">{item.duration_in_minutes ? item.duration_in_minutes : "-"}</div>
                      </div>
                      {/* Image + Name + Contact */}
                      <div className="d-flex align-items-start justify-content-between mb-2 ohgt">
                        <div className="d-flex align-items-start col-9">
                          <img src={item.image_thuumb} alt={item.name} className="img-fluid me-2" />
                          <div className="ms-2 fgtrx">
                            {item.product_type}
                            <div className="fgtrox"> {item.description}</div>
                          </div>
                        </div>
                        <div className="kayde">{item.price}</div>
                      </div>

                      <div className="div">
                        <div className="invvc">Special Instructions</div>
                        <div className="errxoo">{item.special_instructions}</div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={properpage}
                      onChange={handleproRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>
                  {prototalrec > 0 && (
                    <nav>
                      <ul className="pagination pagination-sm mb-0">

                        {prolinks.map((link, index) => {
                          var label = link.label;
                          if (label.includes("Previous")) label = "<";
                          if (label.includes("Next")) label = ">";

                          return (
                            <>
                              <li className={`page-item ${link.active ? "active" : ""}`}>
                                <button
                                  className={`page-link ${!link.url ? "disabled" : ""}`}
                                  onClick={() => {
                                    if (link.url) {
                                      const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                      handleProdPageChange(pageNumber);
                                    }
                                  }}
                                >
                                  {label}
                                </button>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </nav>
                  )}
                </div>
              </>
            )}
          </Card>
        </div>;

      case "coupons":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <div className="d-flex justify-content-between">
              <Card.Title className="d-none d-md-block mb-2">Coupon, Promotion, and AutoSend Management</Card.Title>
              <div className="d-none d-md-block">
                <div>
                  {/* Trigger Button */}
                  <button
                    className="btn canu"
                    onClick={() => setShowCalendarCou(true)}
                  >
                    {selectedRangeCou[0].startDate.toLocaleDateString()} -{" "}
                    {selectedRangeCou[0].endDate.toLocaleDateString()}{" "}
                    <i className="bi bi-calendar"></i>
                  </button>
                  {/* Calendar Popup */}
                  {showCalendarCou && (
                    <div
                      className="calendar-popup-overlay"
                      onClick={closeCalendarCou}
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 9999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="calendar-popup-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          backgroundColor: "#fff",
                          padding: "20px",
                          borderRadius: "8px",
                          maxWidth: "855px",
                          width: "100%",
                          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <DateRangePicker
                          onChange={handleSelectCou}
                          showSelectionPreview={true}
                          moveRangeOnFirstSelection={false}
                          months={2}
                          ranges={selectedRangeCou}
                          direction="horizontal"
                          locale={enUS}
                        />
                        <div className="text-end mt-3">
                          <button className="btn done-btn" onClick={closeCalendarCou}>
                            Done
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Date</th>
                    <th>Expiration Date</th>
                    <th>Coupon Name</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Target Customers</th>
                    <th>Criteria</th>
                    <th>One Time Only</th>
                    <th>Double Coupon Allowed</th>
                  </tr>
                </thead>
                <tbody>
                  {merchantcoupon.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.date}</td>
                      <td>{item.end_date ? item.end_date : "-"}</td>
                      <td onClick={() => handleShow(item)} style={{ cursor: "pointer", textDecorationLine: "underline" }}>{item.coupon_name}</td>
                      <td>{item.coupon_type}</td>
                      <td>{item.description}</td>
                      <td>{item.target_customers ? item.target_customers : "-"}</td>
                      <td>
                        {item.target_customers === "Based on Criteria" ? (
                          <>
                            {item.days_type === "search_customer" ? (
                              <>
                                Has Visited In The Past {item.in_the_past_days} days, Has Spent Over Amount{" "}
                                {item.spent_over_amount}
                              </>
                            ) : (
                              <>Has NOT Returned in The Past {item.visit_days}</>
                            )}
                            <br />
                            Auto Send Coupon: {item.auto_send_coupon === 1 ? "Yes" : "No"}
                          </>
                        ) : item.target_customers === "Selected Customer" ? (
                          <>{item.zip_codes}</>
                        ) : "-"}
                      </td>
                      <td>{item.one_time_used ? 'Yes' : 'No'}</td>
                      <td className="ref">{item.double_coupon_not_allowed ? 'Yes' : 'No'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setcpAccordionOpen(!cpAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Coupon, Promotion, and AutoSend Management</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (cpAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || cpAccordionOpen) && (
              <>
                <div className="d-block d-md-none">
                  <div className="d-flex align-items-center justify-content-end">
                    <div>
                      {/* Trigger Button */}
                      <button
                        className="btn canu"
                        onClick={() => setShowCalendarCou(true)}
                      >
                        {selectedRangeCou[0].startDate.toLocaleDateString()} -{" "}
                        {selectedRangeCou[0].endDate.toLocaleDateString()}{" "}
                        <i className="bi bi-calendar"></i>
                      </button>

                      {/* Calendar Popup */}
                      {showCalendarCou && (
                        <div
                          className="calendar-popup-overlay"
                          onClick={closeCalendarCou}
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0,0,0,0.3)",
                            zIndex: 9999,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div
                            className="calendar-popup-content"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              backgroundColor: "#fff",
                              padding: "20px",
                              borderRadius: "8px",
                              maxWidth: "855px",
                              width: "100%",
                              boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                            }}
                          >
                            <DateRangePicker
                              onChange={handleSelectCou}
                              showSelectionPreview={true}
                              moveRangeOnFirstSelection={false}
                              months={2}
                              ranges={selectedRangeCou}
                              direction="horizontal"
                              locale={enUS}
                            />
                            <div className="text-end mt-3">
                              <button className="btn done-btn" onClick={closeCalendarCou}>
                                Done
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-md-none ev-mobilex">
                  {merchantcoupon.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="joxily">{item.date}</div>
                        <div className="pran">{item.coupon_type}</div>
                      </div>

                      {/* Image + Name + Contact */}
                      <div className="d-flex align-items-start justify-content-between mb-2 jhgfty">
                        <div className="d-flex align-items-start col-9">
                          <img src={process.env.REACT_APP_BASE_URL + 'assests/images/cpans.png'} alt={item.name} className="img-fluid" />
                          <div className="ms-2 fgtrx">
                            {item.coupon_name}
                            <div className="fgtrox"> {item.description}</div>
                          </div>
                        </div>
                        <div className="kayde">{item.target_customers ? item.target_customers : "-"}</div>
                      </div>

                      <div className="row ojuxi">
                        <div className="col-6">
                          <h2>Expiration Date</h2>
                          <h3>{item.end_date ? item.end_date : "-"}</h3>
                        </div>
                        <div className="col-6">
                          <h2>Criteria</h2>
                          <h3>{item.target_customers === "Based on Criteria" ? (
                            <>
                              {item.days_type === "search_customer" ? (
                                <>
                                  Has Visited In The Past {item.in_the_past_days} days, Has Spent Over Amount{" "}
                                  {item.spent_over_amount}
                                </>
                              ) : (
                                <>Has NOT Returned in The Past {item.visit_days}</>
                              )}
                              <br />
                              Auto Send Coupon: {item.auto_send_coupon === 1 ? "Yes" : "No"}
                            </>
                          ) : item.target_customers === "Selected Customer" ? (
                            <>{item.zip_codes}</>
                          ) : "-"}</h3>
                        </div>
                        <div className="col-6">
                          <h2>One Time Only</h2>
                          <h3>{item.one_time_used ? 'Yes' : 'No'}</h3>
                        </div>
                        <div className="col-6">
                          <h2>Double Coupon Allowed</h2>
                          <h3>{item.double_coupon_not_allowed ? 'Yes' : 'No'}</h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={couperpage}
                      onChange={handlecouponRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>

                  {coutotalrec > 0 && (
                    <nav>
                      <ul className="pagination pagination-sm mb-0">

                        {coulinks.map((link, index) => {
                          var label = link.label;
                          if (label.includes("Previous")) label = "<";
                          if (label.includes("Next")) label = ">";

                          return (
                            <>
                              <li className={`page-item ${link.active ? "active" : ""}`}>
                                <button
                                  className={`page-link ${!link.url ? "disabled" : ""}`}
                                  onClick={() => {
                                    if (link.url) {
                                      const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                      handleCouPageChange(pageNumber);
                                    }
                                  }}

                                >
                                  {label}
                                </button>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </nav>
                  )}
                </div>
              </>
            )}
          </Card>
        </div>;

      case "customers":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <div className="d-flex flex-column-reverse flex-md-row justify-content-between align-items-md-center">
              <Card.Title className="d-none d-md-block mb-2">Total Customers Number: {merchantcustotal}</Card.Title>
              <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 d-none d-md-block">
                <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                  <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                    <div className="input-group">
                      <div className="input-group-text border-end-0">
                        <img
                          src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                          alt="Search Icon"
                          className="img-fluid"
                        />
                      </div>
                      <input
                        type="text"
                        className="form-control border-start-0 ps-0"
                        placeholder="Search"
                        value={cuskeyword}
                        onChange={handleCusInputChangeauto}
                      />
                    </div>
                  </div>
                  <button type="button" className="sloti" onClick={handleCusSort}>
                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2" />
                    Sort {sortcusOrder === "asc" ? "(A-Z)" : "(Z-A)"}
                  </button>

                </div>
              </div>
            </div>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Date</th>
                    <th>Customer ID</th>
                    <th>Membership date</th>

                    <th>Amount</th>

                    <th>Receipt #</th>
                    <th>Coupon #</th>
                  </tr>
                </thead>
                <tbody>
                  {merchantcustomer.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.join_date}</td>
                      <td>
                        {parseInt(localStorage.getItem("department")) === 3 || parseInt(localStorage.getItem("department")) === 4 || parseInt(localStorage.getItem("department")) === 7 ? (
                          <Link to={`${process.env.REACT_APP_BASE_URL}dashboard-customer2/${item.id}`}>
                            {item.customers_id}
                          </Link>
                        ) : (
                          <Link to={`${process.env.REACT_APP_BASE_URL}`}>
                            {item.customers_id}
                          </Link>
                        )}
                      </td>

                      <td>{item.membership_date}</td>

                      <td>{item.amount}</td>

                      <td><Link to="#" onClick={() => handleShowcus(item.invoice, item.id)}>Receipt</Link></td>
                      <td className="ref">{item.coupon}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setcpAccordionOpen(!cpAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Total Customers Number: {merchantcustotal}</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (cpAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || cpAccordionOpen) && (
              <>
                <div className="d-md-none ev-mobilex">
                  {merchantcustomer.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="joxily">{item.join_date} - <Link to="#" onClick={() => handleShowcus(item.invoice, item.id)}>Receipt</Link></div>
                        <div className="pran">{item.coupon}</div>
                      </div>

                      {/* Image + Name + Contact */}
                      <div className="d-flex align-items-start justify-content-between ghyt6">
                        <div className="d-flex align-items-start">
                          <div className="fgtrx me-2">
                            {item.amount}
                          </div>
                          <img src={process.env.REACT_APP_BASE_URL + 'assests/images/visa.png'} alt={item.name} className="img-fluid" />
                        </div>
                        {parseInt(localStorage.getItem("department")) === 3 || parseInt(localStorage.getItem("department")) === 4 || parseInt(localStorage.getItem("department")) === 7 ? (
                          <div className="kaysde"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/prifile.png'} alt={item.name} className="img-fluid me-1" /><Link to={`${process.env.REACT_APP_BASE_URL}dashboard-customer2/${item.id}`}>{item.name}</Link></div>
                        ) : (
                          <div className="kaysde"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/prifile.png'} alt={item.name} className="img-fluid me-1" /><Link to={`${process.env.REACT_APP_BASE_URL}`}>{item.name}</Link></div>
                        )}


                      </div>



                      <div className="row ojuxi">
                        <div className="col-8">
                          <h2>Order Date & Time</h2>
                          <h3>{item.membership_date}</h3>
                        </div>

                      </div>
                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={cusperpage}
                      onChange={handlecustomerRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>

                  {custotalrec > 0 && (
                    <nav>
                      <ul className="pagination pagination-sm mb-0">

                        {cuslinks.map((link, index) => {
                          var label = link.label;
                          if (label.includes("Previous")) label = "<";
                          if (label.includes("Next")) label = ">";

                          return (
                            <>
                              <li className={`page-item ${link.active ? "active" : ""}`}>
                                <button
                                  className={`page-link ${!link.url ? "disabled" : ""}`}
                                  onClick={() => {
                                    if (link.url) {
                                      const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                      handleCusPageChange(pageNumber);
                                    }
                                  }}

                                >
                                  {label}
                                </button>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </nav>
                  )}
                </div>
              </>
            )}
          </Card>
        </div>;

      case "income & forecast":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <div className="d-flex flex-column-reverse flex-md-row justify-content-between align-items-md-center">
              <Card.Title className="d-none d-md-block mb-2">Current Month income:  ${merchantcurrentmonthtotal}</Card.Title>
              <div className="d-none d-md-block">
                <div>
                  {/* Trigger Button */}
                  <button
                    className="btn canu"
                    onClick={() => setShowCalendarInc(true)}
                  >
                    {selectedRangeInc[0].startDate.toLocaleDateString()} -{" "}
                    {selectedRangeInc[0].endDate.toLocaleDateString()}{" "}
                    <i className="bi bi-calendar"></i>
                  </button>

                  {/* Calendar Popup */}
                  {showCalendarInc && (
                    <div
                      className="calendar-popup-overlay"
                      onClick={closeCalendarInc}
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 9999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="calendar-popup-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          backgroundColor: "#fff",
                          padding: "20px",
                          borderRadius: "8px",
                          maxWidth: "855px",
                          width: "100%",
                          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <DateRangePicker
                          onChange={handleSelectInc}
                          showSelectionPreview={true}
                          moveRangeOnFirstSelection={false}
                          months={2}
                          ranges={selectedRangeInc}
                          direction="horizontal"
                          locale={enUS}
                        />
                        <div className="text-end mt-3">
                          <button className="btn done-btn" onClick={closeCalendarInc}>
                            Done
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Month</th>
                    <th>Receipt Amount</th>
                    <th>Forecasted Income</th>
                    <th>Income Growing</th>
                    <th>Success Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {merchantincome.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.month}</td>
                      <td>{item.receipt_amount}</td>
                      <td>{item.forecast_income}</td>
                      <td className="ref">{item.income_growing}</td>
                      <td className="ref">{item.success_rate}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setcpAccordionOpen(!cpAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Current Month income:  ${merchantcurrentmonthtotal}</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (cpAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || cpAccordionOpen) && (
              <>
                <div className="w-30 text-end d-block d-md-none">
                  <div>
                    {/* Trigger Button */}
                    <button
                      className="btn canu"
                      onClick={() => setShowCalendar(true)}
                    >
                      {selectedRange[0].startDate.toLocaleDateString()} -{" "}
                      {selectedRange[0].endDate.toLocaleDateString()}{" "}
                      <i className="bi bi-calendar"></i>
                    </button>

                    {/* Calendar Popup */}
                    {showCalendar && (
                      <div
                        className="calendar-popup-overlay"
                        onClick={closeCalendar}
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: "rgba(0,0,0,0.3)",
                          zIndex: 9999,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="calendar-popup-content"
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            backgroundColor: "#fff",
                            padding: "20px",
                            borderRadius: "8px",
                            maxWidth: "855px",
                            width: "100%",
                            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                          }}
                        >
                          <DateRangePicker
                            onChange={handleSelect}
                            showSelectionPreview={true}
                            moveRangeOnFirstSelection={false}
                            months={2}
                            ranges={selectedRange}
                            direction="horizontal"
                            locale={enUS}
                          />
                          <div className="text-end mt-3">
                            <button className="btn done-btn" onClick={closeCalendar}>
                              Done
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-md-none ev-mobilex">
                  {merchantincome.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="joxily">{item.month}</div>

                      </div>

                      <div className="row ojuxi">
                        <div className="col-6">
                          <h2>Receipt Amount</h2>
                          <h3>{item.receipt_amount}</h3>
                        </div>
                        <div className="col-6">
                          <h2>Forecasted Income</h2>
                          <h3>{item.forecast_income}</h3>
                        </div>
                        <div className="col-12">
                          <h2>Income Growing</h2>
                          <h3>{item.income_growing}</h3>
                        </div>
                        <div className="col-12">
                          <h2>Success Rate</h2>
                          <h3>{item.success_rate}</h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

              </>
            )}
          </Card>
        </div>;

      case "workinghours":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <Card.Title className="d-none d-md-block">Working Hours</Card.Title>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Day</th>
                    <th>From</th>
                    <th>To</th>
                  </tr>
                </thead>
                <tbody>
                  {workinghours.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.day}</td>
                      <td>{item.start_hr ? `${item.start_hr}:${item.start_min} ${item.start_am_pm}` : "Close"}</td>
                      <td className="ref">{item.end_hr ? `${item.end_hr}:${item.end_min} ${item.end_am_pm}` : "Close"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setprAccordionOpen(!prAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Working Hours</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (cpAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || prAccordionOpen) && (
              <>
                <div className="d-md-none ev-mobilex">
                  {workinghours.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="joxily">Day</div>
                        <div className="joxily">{item.day}</div>
                      </div>

                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="joxily">From</div>
                        <div className="joxily">{item.start_hr ? `${item.start_hr}:${item.start_min} ${item.start_am_pm}` : "Close"}</div>
                      </div>

                      <div className="d-flex justify-content-between align-items-center">
                        <div className="joxily">To</div>
                        <div className="joxily">{item.end_hr ? `${item.end_hr}:${item.end_min} ${item.end_am_pm}` : "Close"}</div>
                      </div>
                    </div>
                  ))}
                </div>

              </>
            )}
          </Card>
        </div>;


      case "orders/appointments":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <div className="d-flex flex-column-reverse flex-md-row align-items-md-center justify-content-end">

              <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0 d-none d-md-block">
                <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                  <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                    <div className="input-group">
                      <div className="input-group-text border-end-0">
                        <img
                          src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                          alt="Search Icon"
                          className="img-fluid"
                        />
                      </div>
                      <input
                        type="text"
                        className="form-control border-start-0 ps-0"
                        placeholder="Search"
                        value={ordkeyword}
                        onChange={handleOrdInputChangeauto}
                      />
                    </div>
                  </div>
                  <button type="button" className="sloti" onClick={handleOrdSort}>
                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2" />
                    Sort {sortordOrder === "asc" ? "(Oldest First)" : "(Newest First)"}
                  </button>

                </div>
              </div>
            </div>
            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Order Date</th>
                    <th>Customer</th>
                    <th>Order Details</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Payment method</th>
                    <th>Zip Code</th>
                    <th>Receipt #</th>
                  </tr>
                </thead>
                <tbody>
                  {merchantorder.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.date}</td>
                      <td>
                        {parseInt(localStorage.getItem("department")) === 3 || parseInt(localStorage.getItem("department")) === 4 || parseInt(localStorage.getItem("department")) === 7 ? (
                          <Link to={`${process.env.REACT_APP_BASE_URL}dashboard-customer2/${item.user_id}`}>
                            {item.full_name}
                          </Link>
                        ) : (
                          <Link to={`${process.env.REACT_APP_BASE_URL}`}>
                            {item.full_name}
                          </Link>
                        )}
                      </td>
                      <td>{item.order_number}</td>
                      <td>{item.amount}</td>
                      <td>{item.status_name}</td>
                      <td>{item.payment_method}</td>
                      <td>{item.zip_code ? `${item.zip_code}` : '-'}</td>
                      <td><Link to={process.env.REACT_APP_BASE_URL + "custmssmer-receipts/" + item.id + "/" + item.user_id} >{item.order_number}</Link></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setcpAccordionOpen(!cpAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Orders/Appointments</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (cpAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || cpAccordionOpen) && (
              <>
                <div className="d-md-none ev-mobilex">
                  {merchantorder.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="joxily">{item.date} - <Link to={process.env.REACT_APP_BASE_URL + "custmssmer-receipts/" + item.id + "/" + item.user_id} >{item.order_number}</Link></div>
                        <div className="pran">{item.full_name}</div>
                      </div>

                      {/* Image + Name + Contact */}
                      <div className="d-flex align-items-start justify-content-between ghyt6">
                        <div className="d-flex align-items-start">
                          <div className="fgtrx me-2">
                            {item.amount}
                          </div>

                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={ordperpage}
                      onChange={handleorderRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>

                  {ordtotalrec > 0 && (
                    <nav>
                      <ul className="pagination pagination-sm mb-0">

                        {ordlinks.map((link, index) => {
                          var label = link.label;
                          if (label.includes("Previous")) label = "<";
                          if (label.includes("Next")) label = ">";

                          return (
                            <>
                              <li className={`page-item ${link.active ? "active" : ""}`}>
                                <button
                                  className={`page-link ${!link.url ? "disabled" : ""}`}
                                  onClick={() => {
                                    if (link.url) {
                                      const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                      handleOrdPageChange(pageNumber);
                                    }
                                  }}

                                >
                                  {label}
                                </button>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </nav>
                  )}
                </div>
              </>
            )}
          </Card>
        </div>;
      default:
        return null;
    }
  };
  useEffect(() => {
    document.title = `Merchants-Subscription | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', id);
    API.post('backoffice_merchant_detail', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          //var url=process.env.REACT_APP_BASE_URL_BLUEFAUCET+'signup?key='+response.data.data.token+'&type=direct';
          var url = process.env.REACT_APP_BASE_URL_BLUEFAUCET + 'store-details/' + response.data.data.id;
          setInputs({
            id: response.data.data.id,
            store_name: response.data.data.store_name,
            merchant_id: response.data.data.merchant_id,
            join_date: response.data.data.join_date,
            street_name: response.data.data.street_name,
            logo: response.data.data.logo,
            owner_name: response.data.data.owner_name,
            dob: response.data.data.dob,
            category_name: response.data.data.category_name,
            stripe_express: response.data.data.stripe_express,
            mobile: response.data.data.mobile,
            salesperson: response.data.data.salesperson,
            subcategory_name: response.data.data.subcategory_name,
            subscription_status: response.data.data.subscription_status,
            accepted_per_time_slot: response.data.data.accepted_per_time_slot,
            auto_accept_during_working_hours: response.data.data.auto_accept_during_working_hours,
            store_email: response.data.data.store_email,
            no_of_customers: response.data.data.no_of_customers,
            be_confirmed: response.data.data.be_confirmed,
            auto_refuse: response.data.data.auto_refuse,
            url: url,
            sales_id: response.data.data.sales_id,
            store_policy: response.data.data.store_policy
          });

          setEmployeesubscription(response.data.data.employee_subscription);
          setPaymenthistory(response.data.data.payment_history.data);
          setPaylinks(response.data.data.payment_history.links);
          setPaytotalrec(response.data.data.payment_history.total);
          setWorkinghours(response.data.data.working_hours);
        }
      }).catch(error => {
        setLoading(false);
      });
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [id]);

  const getCoupontype = (val, discount_percentage, minimum_purchase_amount, item_name_buy, product_item_name, buy_qty, get_qty) => {
    var type = '';
    if (val === 'Buy & Get') {
      type = 'Buy  ' + buy_qty + ' ' + item_name_buy + ' and Get ' + get_qty + ' ' + product_item_name + ' free of Charge';
    } else if (val === 'Discount Offer') {
      type = discount_percentage + '% discount when purchase over $' + minimum_purchase_amount;
    } else {
      type = val;
    }
    return type;
  }

  const shareAll = () => {
    const url = inputs.url;

    navigator.clipboard.writeText(url)
      .then(() => {
        gettoastsuccess('Link copied to clipboard', '');
      })
      .catch(err => {
        console.error('Failed to copy:', err);
      });
  }


  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header tabHeaderName={tabHeaderNames[activeTab]} />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12">
                    <h1>{tabHeadings[activeTab] || "Merchant Profile"}</h1>
                    <div className="vnfro">
                      <div className="d-flex align-items-start justify-content-between gap-2 flex-wrap mb-4 kjuk">
                        {/* Profile Image */}
                        <div className="d-flex align-items-start gap-3">
                          <div className="leki flex-shrink-0">
                            <img src={inputs.logo} alt="Profile" className="img-fluid" />
                            <div onClick={handleQRClick} className="d-block d-md-none hello-qr mt-2">
                              QR <img src={process.env.REACT_APP_BASE_URL + 'assests/images/qeo.png'} alt="qr" className="img-fluid houi" />
                            </div>
                            <Modal
                              show={showQRPopup}
                              onHide={() => setShowQRPopup(false)}
                              centered
                              className="d-md-none"
                            >
                              <Modal.Header className="pb-0 border-bottom-0" closeButton>
                                <Modal.Title>QR Codes</Modal.Title>
                              </Modal.Header>
                              <Modal.Body className="text-center">
                                <img
                                  src={process.env.REACT_APP_BASE_URL + 'assests/images/qr.png'}
                                  alt="QR 1"
                                  className="img-fluid"
                                />
                                {/*<img
                                  src={process.env.REACT_APP_BASE_URL + 'assests/images/qr.png'}
                                  alt="QR 2"
                                  className="img-fluid"
                                />*/}
                              </Modal.Body>
                            </Modal>
                          </div>
                          {/* Store Info */}
                          <div className="infea">
                            <p>Store Name</p>
                            <h5>{inputs.store_name}</h5>
                            <div className="ids">ID #{inputs.merchant_id}</div>
                            <div className="aank d-flex"><div className="date">Join Date:</div>{inputs.join_date}</div>
                            <div className="aank d-flex"><div className="date oji">Address:</div>{inputs.street_name}</div>
                            <div className="aank d-flex"><div className="date oji">Merchant's URL :</div><Link to="#" onClick={shareAll}> Copy</Link> </div>
                          </div>
                        </div>
                        {/* QR Codes */}
                        <div className="d-flex d-none d-md-block text-end">
                          {/*<img
                            src={process.env.REACT_APP_BASE_URL + 'assests/images/qr.png'}
                            alt="QR 1"
                            className="img-fluid"
                          />*/}
                          {/*<img
                            src={process.env.REACT_APP_BASE_URL + 'assests/images/qr.png'}
                            alt="QR 2"
                            className="img-fluid"
                          />*/}
                          <QRCodeSVG
                            value={inputs.url}
                            width="150px"
                            height="150px"
                          />
                        </div>
                      </div>

                      {/* Desktop */}
                      <div className="row mt-3 d-none d-md-flex">
                        <div className="col-md-4">
                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Owner Name:</div>
                            <div className="col-6 latly">{inputs.owner_name}</div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">DOB:</div>
                            <div className="col-6 latly">{inputs.dob}</div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Category:</div>
                            <div className="col-6 latly">{inputs.category_name}</div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Stripe Express:</div>
                            <div className="col-6 latly">{inputs.stripe_express ? 'Yes' : 'N/A'}</div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Store Policy and Refund Policy:</div>
                            <div className="col-6 latly">{inputs.store_policy}</div>
                          </div>
                          {/*<div className="row mb-3">
                            <div className="col-5 text-start tatly">Credit Card account:</div>
                            <div className="col-6 latly">2155*********215</div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Bank account:</div>
                            <div className="col-6 latly">2155*********215</div>
                          </div>*/}
                        </div>

                        <div className="col-md-4">
                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Phone Number</div>
                            <div className="col-6 latly">{inputs.mobile}</div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Salesperson Name</div>
                            <div className="col-6 latly">
                              {inputs.salesperson ? (
                                <Link
                                  to={process.env.REACT_APP_BASE_URL + 'salesperson-Information/' + inputs.sales_id}
                                  className="table-link"
                                >
                                  {inputs.salesperson}
                                </Link>
                              ) : (
                                'N/A'
                              )}
                            </div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Subcategory</div>
                            <div className="col-6 latly">{inputs.subcategory_name}</div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Status</div>
                            <div className="col-6 latly">{inputs.subscription_status}</div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Customers can be accepted per hour</div>
                            <div className="col-6 latly">{inputs.accepted_per_time_slot}</div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Auto Accept During Working Hours</div>
                            <div className="col-6 latly">{inputs.auto_accept_during_working_hours ? 'Yes' : 'N/A'}</div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Email</div>
                            <div className="col-6 latly">{inputs.store_email}</div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">No. of Customers</div>
                            <div className="col-6 latly">{inputs.no_of_customers}</div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">KYC</div>
                            <div className="col-6 latly">{inputs.stripe_express ? 'Verified' : 'Unverified'}</div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Need Confirmation</div>
                            <div className="col-6 latly">{inputs.be_confirmed ? 'Yes' : 'N/A'}</div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-5 text-start tatly">Auto Refuse</div>
                            <div className="col-6 latly">{inputs.auto_refuse ? 'Yes' : 'N/A'}</div>
                          </div>
                        </div>
                      </div>
                      {/* Mobile */}
                      <div className="row mt-3 d-md-none">
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Owner Name</div>
                          <div className="latly">{inputs.owner_name}</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Phone Number</div>
                          <div className="latly">{inputs.mobile}</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Email</div>
                          <div className="latly">{inputs.store_email}</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">DOB</div>
                          <div className="latly">{inputs.dob}</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Salesperson Name</div>
                          <div className="latly"><Link to={process.env.REACT_APP_BASE_URL + 'merchant-subscription'} className="table-link">{inputs.salesperson ? inputs.salesperson : 'N/A'}</Link></div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">No. of Customers</div>
                          <div className="latly">{inputs.no_of_customers}</div>
                        </div>

                        <div className="col-md-4 col-4 mb-3">
                          <div className="text-start tatly">Category</div>
                          <div className="latly">{inputs.category_name}</div>
                        </div>
                        <div className="col-md-4 col-4 mb-3">
                          <div className="text-start tatly">Subcategory</div>
                          <div className="latly">{inputs.subcategory_name}</div>
                        </div>

                        <div className="col-md-4 col-4 mb-3">
                          <div className="text-start tatly">KYC</div>
                          <div className="latly">{inputs.stripe_express ? 'Verified' : 'Unverified'}</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Stripe Express</div>
                          <div className="latly">{inputs.stripe_express ? 'Yes' : 'N/A'}</div>
                        </div>

                        {/*<div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Credit Card account</div>
                          <div className="latly">2155*********215</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Bank account</div>
                          <div className="latly">2155*********215</div>
                        </div>*/}

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Status</div>
                          <div className="latly">{inputs.subscription_status}</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Customers can be accepted per hour</div>
                          <div className="latly">{inputs.accepted_per_time_slot}</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Auto Accept During Working Hours</div>
                          <div className="latly">{inputs.auto_accept_during_working_hours ? 'Yes' : 'N/A'}</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Need Confirmation</div>
                          <div className="latly">{inputs.be_confirmed ? 'Yes' : 'N/A'}</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Auto Refuse</div>
                          <div className="latly">{inputs.auto_refuse ? 'Yes' : 'N/A'}</div>
                        </div>
                      </div>

                      {/* Footer Tabs (Nav Tabs Style) */}
                      <ul className="nav nav-tabs mt-4 d-none d-md-flex gap-2">
                        {[
                          { key: "subscription status", label: "Subscription Status" },
                          { key: "employees", label: "Employees" },
                          { key: "products", label: "Products" },
                          { key: "coupons", label: "Coupons" },
                          { key: "customers", label: "Customers" },
                          { key: "income & forecast", label: "Income & Forecast" },
                          { key: "workinghours", label: "Working Hours" },
                          { key: "orders/appointments", label: "orders/appointments" },
                        ].map((tab) => (
                          <li className="nav-item" key={tab.key}>
                            <button
                              className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                              onClick={() => setGetActiveTab(tab.key)}
                            >
                              {tab.label}
                            </button>
                          </li>
                        ))}
                      </ul>

                      {/* Footer Monile (Nav Tabs Style) */}
                      <div className="d-md-none mt-4">
                        <ul className="nav nav-tabs overflow-x-auto flex-nowrap text-nowrap">
                          {[
                            { key: "subscription status", label: "Subscription Status" },
                            { key: "employees", label: "Employees" },
                            { key: "products", label: "Products" },
                            { key: "coupons", label: "Coupons" },
                            { key: "customers", label: "Customers" },
                            { key: "income & forecast", label: "Income & Forecast" },
                            { key: "workinghours", label: "Working Hours" },
                            { key: "orders/appointments", label: "orders/appointments" },
                          ].map((tab) => (
                            <li className="nav-item" key={tab.key}>
                              <button
                                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                                onClick={() => setGetActiveTab(tab.key)}
                              >
                                {tab.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 gytf">{renderTabContent()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ========== Start Coupon Modal ========== */}
      <Modal show={show} onHide={handleClose} className="popupwrngcnt">
        <Modal.Header closeButton>
          <h3 className="mdlttltxt">Coupon</h3>
        </Modal.Header>
        <Modal.Body>
          <Col md={12} xs={12} className="ppinpt">
            <Col className="mb-3 main-copn">
              {(() => {
                if (couponmodal.image === '3') {
                  return (<Row className="mx-0 third-copn mb-2">
                    <Col className="align-self-end text-white col copn-text text-end mb-5 px-5">
                      <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                      <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                      <p className="text-dark">{getCoupontype(couponmodal.coupon_type, couponmodal.discount_percentage, couponmodal.minimum_purchase_amount, couponmodal.item_name_buy, couponmodal.product_item_name, couponmodal.buy_quantity, couponmodal.get_quantity)}</p>
                      <p className="text-dark">{couponmodal.description}</p>
                      {couponmodal.return_befor === '' ? (
                        <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> &nbsp;&nbsp;End Date :<span>{couponmodal.end_date}</span> </p>
                      ) : (
                        <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                      )}
                    </Col>
                  </Row>)
                } else if (couponmodal.image === '4') {
                  return (<Col className="mb-3 main-copn">
                    {(() => {
                      if (couponmodal.coupon_type === 'Welcome coupon') {
                        return (<Row className="mx-0 four-copn ">
                          <Col className="align-self-end text-dark col copn-text text-end">
                            <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                            <p className="text-dark">{couponmodal.discount_percentage}% for all new members joining your membership has been set up</p>
                          </Col>
                        </Row>)
                      } else {
                        return (<Row className="mx-0 four-copn ">
                          <Col className="align-self-end text-dark col copn-text text-end">
                            <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                            <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                            <p className="text-dark">{getCoupontype(couponmodal.coupon_type, couponmodal.discount_percentage, couponmodal.minimum_purchase_amount, couponmodal.item_name_buy, couponmodal.product_item_name, couponmodal.buy_quantity, couponmodal.get_quantity)}</p>
                            <p className="text-dark">{couponmodal.description}</p>
                            {couponmodal.return_befor === '' ? (
                              <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> &nbsp;&nbsp;End Date :<span>{couponmodal.end_date}</span> </p>
                            ) : (
                              <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                            )}
                          </Col>
                        </Row>)
                      }
                    })()}
                  </Col>)
                } else if (couponmodal.image === '5') {
                  return (<Row className="mx-0 five-copn justify-content-center ">
                    <Col md={6} xs={8} className="align-self-center text-dark col copn-text col-6 ">
                      <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                      <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                      <p className="text-dark">{getCoupontype(couponmodal.coupon_type, couponmodal.discount_percentage, couponmodal.minimum_purchase_amount, couponmodal.item_name_buy, couponmodal.product_item_name, couponmodal.buy_quantity, couponmodal.get_quantity)}</p>
                      <p className="text-dark">{couponmodal.description}</p>
                      {couponmodal.return_befor === '' ? (
                        <>
                          <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                          <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                        </>
                      ) : (
                        <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                      )}
                    </Col>
                  </Row>)
                } else if (couponmodal.image === '6') {
                  return (<Row className="mx-0 six-copn justify-content-center ">
                    <Col md={6} xs={8} className="align-self-center text-dark col copn-text col-6 ">
                      <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                      <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                      <p className="text-dark">{getCoupontype(couponmodal.coupon_type, couponmodal.discount_percentage, couponmodal.minimum_purchase_amount, couponmodal.item_name_buy, couponmodal.product_item_name, couponmodal.buy_quantity, couponmodal.get_quantity)}</p>
                      <p className="text-dark">{couponmodal.description}</p>
                      {couponmodal.return_befor === '' ? (
                        <>
                          <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                          <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                        </>
                      ) : (
                        <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                      )}
                    </Col>
                  </Row>)
                } else if (couponmodal.image === '7') {
                  return (<Row className="mx-0 seven-copn justify-content-end ">
                    <Col md={6} xs={8} className="align-self-center text-white col copn-text text-end col-6 mt-5">
                      <h5 className="">{couponmodal.coupon_name}</h5>
                      <p>Welcome to {couponmodal.store_name}</p>
                      <p>{getCoupontype(couponmodal.coupon_type, couponmodal.discount_percentage, couponmodal.minimum_purchase_amount, couponmodal.item_name_buy, couponmodal.product_item_name, couponmodal.buy_quantity, couponmodal.get_quantity)}</p>
                      <p>{couponmodal.description}</p>
                      {couponmodal.return_befor === '' ? (
                        <>
                          <p>Start Date : <span>{couponmodal.start_date}</span> </p>
                          <p>End Date :<span>{couponmodal.end_date}</span> </p>
                        </>
                      ) : (
                        <p>Return Before : <span>{couponmodal.return_befor}</span> </p>
                      )}
                    </Col>
                  </Row>)
                } else if (couponmodal.image === '8') {
                  return (<Row className="mx-0 eight-copn justify-content-center">
                    <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                      <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                      <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                      <p className="text-dark">{getCoupontype(couponmodal.coupon_type, couponmodal.discount_percentage, couponmodal.minimum_purchase_amount, couponmodal.item_name_buy, couponmodal.product_item_name, couponmodal.buy_quantity, couponmodal.get_quantity)}</p>
                      <p className="text-dark">{couponmodal.description}</p>
                      {couponmodal.return_befor === '' ? (
                        <>
                          <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                          <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                        </>
                      ) : (
                        <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                      )}
                    </Col>
                  </Row>)
                } else if (couponmodal.image === '9') {
                  return (<Row className="mx-0 nine-copn justify-content-center">
                    <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                      <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                      <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                      <p className="text-dark">{getCoupontype(couponmodal.coupon_type, couponmodal.discount_percentage, couponmodal.minimum_purchase_amount, couponmodal.item_name_buy, couponmodal.product_item_name, couponmodal.buy_quantity, couponmodal.get_quantity)}</p>
                      <p className="text-dark">{couponmodal.description}</p>
                      {couponmodal.return_befor === '' ? (
                        <>
                          <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                          <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                        </>
                      ) : (
                        <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                      )}
                    </Col>
                  </Row>)
                } else if (couponmodal.image === '10') {
                  return (<Row className="mx-0 ten-copn justify-content-center">
                    <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                      <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                      <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                      <p className="text-dark">{getCoupontype(couponmodal.coupon_type, couponmodal.discount_percentage, couponmodal.minimum_purchase_amount, couponmodal.item_name_buy, couponmodal.product_item_name, couponmodal.buy_quantity, couponmodal.get_quantity)}</p>
                      <p className="text-dark">{couponmodal.description}</p>
                      {couponmodal.return_befor === '' ? (
                        <>
                          <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                          <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                        </>
                      ) : (
                        <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                      )}
                    </Col>
                  </Row>)
                } else if (couponmodal.image === '11') {
                  return (<Row className="mx-0 eleven-copn justify-content-center">
                    <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                      <h5 className="text-dark">{couponmodal.coupon_name}</h5>
                      <p className="text-dark">Welcome to {couponmodal.store_name}</p>
                      <p className="text-dark">{getCoupontype(couponmodal.coupon_type, couponmodal.discount_percentage, couponmodal.minimum_purchase_amount, couponmodal.item_name_buy, couponmodal.product_item_name, couponmodal.buy_quantity, couponmodal.get_quantity)}</p>
                      <p className="text-dark">{couponmodal.description}</p>
                      {couponmodal.return_befor === '' ? (
                        <>
                          <p className="text-dark">Start Date : <span>{couponmodal.start_date}</span> </p>
                          <p className="text-dark">End Date :<span>{couponmodal.end_date}</span> </p>
                        </>
                      ) : (
                        <p className="text-dark">Return Before : <span>{couponmodal.return_befor}</span> </p>
                      )}
                    </Col>
                  </Row>)
                }
              })()}
            </Col>
          </Col>
        </Modal.Body>
      </Modal>
      <Modal centered show={show2} onHide={handleClose2}>
        <Modal.Body className="p-0">
          <Col md={12} xs={12} className="pt-2">
            <Col className="ustrlpg">
              <Row className="mx-0 ustrl-box">
                <Col md={2} xs={2} className="px-0">
                  <Link to="#">
                    <img src="assests/images/coupan-5.png" className="img-fluid" alt="Hm Img" />
                  </Link>
                </Col>
                <Col md={9} xs={9} className="px-2 px-md-2">
                  <h3>Test</h3>
                  <p className="mt-2">Price 100</p>
                  <p className="mt-2">Price 100</p>
                  <div className="dwnnewpgcnt">
                    <ul>
                      <li>$100.00</li>
                    </ul>
                  </div>
                </Col>
                <Col md={1} xs={1} className="text-end likedv">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleClose2}
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      fontSize: "14px",
                      height: "10px",
                      width: "20px",
                    }}
                  ></button>
                </Col>
              </Row>
              <Col md={12} xs={12} className="ustrl-crdlst newpgcl">
                <div>
                  <p>Availability: <span>in stock</span></p>
                </div>
              </Col>
            </Col>
          </Col>
        </Modal.Body>
      </Modal>

      <Modal show={show3} onHide={handleClose3} className="popupwrngcnt">
        <Modal.Header closeButton>
          <h3 className="mdlttltxt">Coupon</h3>
        </Modal.Header>

        <Modal.Body>
          <Col md={12} xs={12} className="ppinpt">
            <Col className="mb-3 main-copn">
              <Row className="mx-0 third-copn mb-2">
                <Col className="align-self-end text-white col copn-text text-end mb-5 px-5">
                  <h5 className="text-dark">return visit coupon</h5>
                  <p className="text-dark">10% discount when purchase over $100</p>
                  <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                  <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                </Col>
              </Row>

              {/* <Row className="mx-0 four-copn ">
                <Col className="align-self-end text-dark col copn-text text-end">
                  <h5 className="text-dark">return visit coupon</h5>
                  <p className="text-dark">10% discount when purchase over $100</p>
                  <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                  <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                </Col>
              </Row> */}

              {/* <Row className="mx-0 five-copn justify-content-center ">
                <Col md={6} xs={8} className="align-self-center text-dark col copn-text col-6 ">
                  <h5 className="text-dark">return visit coupon</h5>
                  <p className="text-dark">10% discount when purchase over $100</p>
                  <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                  <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                </Col>
              </Row> */}

              {/* <Row className="mx-0 six-copn justify-content-center ">
                <Col md={6} xs={8} className="align-self-center text-dark col copn-text col-6 ">
                  <h5 className="text-dark">return visit coupon</h5>
                  <p className="text-dark">10% discount when purchase over $100</p>
                  <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                  <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                </Col>
              </Row> */}

              {/* <Row className="mx-0 seven-copn justify-content-end ">
                <Col md={6} xs={8} className="align-self-center text-white col copn-text text-end col-6 mt-5">
                  <h5 className="">return visit coupon</h5>
                  <p>10% discount when purchase over $100</p>
                  <p>We miss you, please come back soon and enjoy the discount</p>
                  <p>Return Before : <span>28/08/2025</span> </p>
                </Col>
              </Row> */}

              {/* <Row className="mx-0 eight-copn justify-content-center">
                <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                  <h5 className="text-dark">return visit coupon</h5>
                  <p className="text-dark">10% discount when purchase over $100</p>
                  <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                  <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                </Col>
              </Row> */}

              {/* <Row className="mx-0 nine-copn justify-content-center">
                <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                  <h5 className="text-dark">return visit coupon</h5>
                  <p className="text-dark">10% discount when purchase over $100</p>
                  <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                  <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                </Col>
              </Row> */}

              {/* <Row className="mx-0 ten-copn justify-content-center">
                <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                  <h5 className="text-dark">return visit coupon</h5>
                  <p className="text-dark">10% discount when purchase over $100</p>
                  <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                  <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                </Col>
              </Row> */}

              {/* <Row className="mx-0 eleven-copn justify-content-center">
                <Col md={7} xs={9} className="align-self-center text-dark col copn-text col-6 mt-5">
                  <h5 className="text-dark">return visit coupon</h5>
                  <p className="text-dark">10% discount when purchase over $100</p>
                  <p className="text-dark">We miss you, please come back soon and enjoy the discount</p>
                  <p className="text-dark">Return Before : <span>28/08/2025</span> </p>
                </Col>
              </Row> */}
            </Col>
          </Col>
        </Modal.Body>
      </Modal>
      {/* ========== End Coupon Modal ========== */}

      <Modal centered show={showcus} onHide={handleClosecus} className="ps-0">
        <Modal.Body className="p-0">
          <Col md={12} xs={12}>
            <div className="col-12 holisti">
              <Card className="h-100">
                <div className="table-ro">
                  <Table
                    responsive
                    className="table-no-last-border mb-0"
                  >
                    <thead className="table">
                      <tr className="custom-header">
                        <th className="lft">Date</th>
                        <th>Receipt #</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {merchantcusrec.length > 0 ? (
                        merchantcusrec.map((item, index) => (
                          <tr key={index}>
                            <td>{item.date}</td>
                            <td><Link to={`${process.env.REACT_APP_BASE_URL}custmss-receipts/${item.order_id}/${merchantcusrecid}`}>{item.order_number}</Link></td>
                            <td className="ref">{item.amount}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card>
            </div>
          </Col>
        </Modal.Body>
      </Modal>

      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  );
};

export default MerchantSubscription;